(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("consortium-contabilidad-recibidas", {
                parent: "entity",
                url: "/consortium-contabilidad-recibidas?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumContabilidadRecibidas",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-contabilidad/consortium-contabilidad-recibidas/consortium-contabilidad-recibidas.html",
                        controller: "ConsortiumContabilidadRecibidaController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("consortium-contabilidad-recibidas.new", {
                parent: "consortium-contabilidad-recibidas",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-contabilidad/consortium-contabilidad-recibidas/consortium-contabilidad-recibidas-new.html",
                        controller:
                            "ConsortiumContabilidadRecibidaNewController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Nuevo",
                    parent: "consortium-contabilidad-recibidas",
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name:
                                    $state.current.name ||
                                    "consortium-contabilidad-recibidas",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("consortium-contabilidad-recibidas.edit", {
                parent: "consortium-contabilidad-recibidas",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumContabilidadRecibidas",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-contabilidad/consortium-contabilidad-recibidas/consortium-contabilidad-recibidas-detail.html",
                        controller:
                            "ConsortiumContabilidadRecibidaDetailController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "consortium-contabilidad-recibidas",
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "ConsortiumContabilidadRecibida",
                        function (
                            $stateParams,
                            ConsortiumContabilidadRecibida
                        ) {
                            return ConsortiumContabilidadRecibida.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name:
                                    $state.current.name ||
                                    "consortium-contabilidad-recibidas",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            });
    }
})();
